import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterProductDetailPage } from './master-product-detail.page';

const routes: Routes = [
  {
    path: '',
    component: MasterProductDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterProductDetailPageRoutingModule {}
